import { createSlice } from '@reduxjs/toolkit';
import { fetchDefaultWellTestDataAsync } from '../../dispatchers/DefaultWellTestDispatcher';
import { DefaultWellTestData } from '../../types/wellTestTypes';

interface DefaultWellTestState {
  data: { values: DefaultWellTestData[] } | null;
  loading: boolean;
  error: string | null;
  currentAssetId: string | null;
}

const initialState: DefaultWellTestState = {
  data: null,
  loading: false,
  error: null,
  currentAssetId: null,
};

const DefaultWellTestSlice = createSlice({
  name: 'DefaultWellTest',
  initialState,
  reducers: {
    setDefaultWellTestInitialState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.currentAssetId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefaultWellTestDataAsync.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.currentAssetId = action.meta.arg;
      })
      .addCase(fetchDefaultWellTestDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchDefaultWellTestDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch Default well test data';
        state.currentAssetId = null;
      });
  },
});

export const { setDefaultWellTestInitialState } = DefaultWellTestSlice.actions;
export default DefaultWellTestSlice.reducer;
